import type { ComponentProps } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../../lib/utils";
import { Z_INDEX } from "../../lib/z-index";

export type TooltipContentProps = ComponentProps<typeof TooltipPrimitive.Content> & {
  hideArrow?: boolean;
};

export const TooltipContent = ({ className, sideOffset = 0, children, hideArrow, ...props }: TooltipContentProps) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      data-slot="tooltip-content"
      sideOffset={sideOffset}
      className={cn(
        "w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        Z_INDEX.tooltip,
        className
      )}
      {...props}
    >
      {children}
      {!hideArrow && (
        <TooltipPrimitive.Arrow className="bg-primary fill-primary size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" />
      )}
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
);
